var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { equal, not, alias } from '@ember/object/computed';
import { set } from '@ember/object';
import { attr } from '@ember-data/model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Enum from '@square/dashboard-utilities/utils/enum';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export const VendorState = new Enum(['VENDOR_DO_NOT_USE', 'VENDOR_ACTIVE', 'VENDOR_INACTIVE']);
let Vendor = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = fragment('squareup/common/location/global-address-ed'), _dec5 = alias('contacts.firstObject.name'), _dec6 = alias('contacts.firstObject.emailAddress'), _dec7 = alias('contacts.firstObject.phoneNumber'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('enum', {
  enumClass: VendorState
}), _dec11 = attr('number'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = fragmentArray('squareup/inventory/v3/vendor-contact'), _dec15 = equal('state', VendorState.VENDOR_ACTIVE), _dec16 = not('isActive'), (_class = (_class2 = class Vendor extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "token", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "addressToken", _descriptor5, this);
    _initializerDefineProperty(this, "address", _descriptor6, this);
    _initializerDefineProperty(this, "contactName", _descriptor7, this);
    _initializerDefineProperty(this, "email", _descriptor8, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor9, this);
    _initializerDefineProperty(this, "accountNumber", _descriptor10, this);
    _initializerDefineProperty(this, "notes", _descriptor11, this);
    _initializerDefineProperty(this, "state", _descriptor12, this);
    _initializerDefineProperty(this, "createdAt", _descriptor13, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor14, this);
    _initializerDefineProperty(this, "version", _descriptor15, this);
    _initializerDefineProperty(this, "contacts", _descriptor16, this);
    _initializerDefineProperty(this, "isActive", _descriptor17, this);
    _initializerDefineProperty(this, "isDisabled", _descriptor18, this);
  }
  init(...args) {
    super.init(...args);
    if (!this.address) {
      this.set('address', this.store.createFragment('squareup/common/location/global-address-ed'));
    }
    if (!this.address.countryCode) {
      // NB(seanluong): We disable the linting rule to import `appCurrentUser` so that we can use the current user's
      // country code as the default for the address. It's no longer correct to use 'US' because we have launched
      // products in several other countries, and using 'US' could lead to some parts of Dashboard making incorrect
      // assumptions regarding vendor addresses, which could result in unstable behavior.
      this.address.set('countryCode', this.userInfo.countryCode);
    }
    if (isEmpty(this.contacts)) {
      this.contacts.createFragment({});
    }
  }
  beforeSave() {
    // remove the contact if it is both new and removed
    // or if contact is removed and has no token
    set(this, 'contacts', this.contacts.reject(contact => contact.isNew && contact.isRemoved || !contact.token && contact.isRemoved));
    this.contacts.forEach((contact, index) => {
      if (contact.isRemoved) {
        contact.set('removed', true);
      }
      contact.set('ordinal', index);
    });
    if (this.isNew) {
      // for new vendors we want to clean up the whitespace before sending to server
      this.name = this.name.trim();
    }
  }
  save() {
    this.beforeSave();
    return super.save();
  }
}, _defineProperty(_class2, "url", '/api/v2/inventory/vendors'), _defineProperty(_class2, "_modelNameForMigration", 'squareup/inventory/v3/vendor'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "token", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addressToken", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contactName", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "accountNumber", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isActive", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "isDisabled", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Vendor as default };